import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import CouponItem from './CouponItem.vue';
import { getPromotionStatusByPromotionIds, getPromotionInfosByPromotionIds, redeemPromotionForCurrentCustomer } from '@/models/api/promotionApi';
import { convertListToQueryParameter } from '@/utils/common';
import constants, { encryptedMarketplaceId } from '@/constants';
import { API_RESPONSE_STATUS_CODE } from '@/configs/common';
import { getKeywordHighlightPart, getCouponThresholdDescription } from '@/views/couponsList/config';
import { Bridge } from '@/utils/bridge';
import { showToast } from 'vant';
import { COUPON_STATUS, DEFAULT_SHOWN_COUPON_NUM, IS_AUTHENTICATED, PROMOTION_SUB_CATEGORY } from '@/configs/views/couponWidget';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { useLess } from '@/models/hooks';
import { useRoute } from 'vue-router';
export default {
  __name: 'CouponWidget',
  props: {
    properties: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ['updateSlideHeight'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/landingPage/couponWidget/CouponWidget.less');
    var route = useRoute();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var couponListContainerRef = ref();
    var isShowAllCoupon = ref(false);
    var couponList = ref([]);
    var cptCouponListStyle = computed(() => {
      if (couponList.value.length > DEFAULT_SHOWN_COUPON_NUM && !isShowAllCoupon.value) {
        var _couponListContainerR, _couponListContainerR2, _couponListContainerR3, _couponListContainerR4;
        var couponItem = (_couponListContainerR = couponListContainerRef.value) === null || _couponListContainerR === void 0 ? void 0 : (_couponListContainerR2 = _couponListContainerR.children) === null || _couponListContainerR2 === void 0 ? void 0 : _couponListContainerR2[0];
        var couponItemSecond = (_couponListContainerR3 = couponListContainerRef.value) === null || _couponListContainerR3 === void 0 ? void 0 : (_couponListContainerR4 = _couponListContainerR3.children) === null || _couponListContainerR4 === void 0 ? void 0 : _couponListContainerR4[1];
        var space = (couponItemSecond === null || couponItemSecond === void 0 ? void 0 : couponItemSecond.offsetTop) - (couponItem === null || couponItem === void 0 ? void 0 : couponItem.offsetTop) - (couponItem === null || couponItem === void 0 ? void 0 : couponItem.clientHeight) || 0;
        return {
          height: `${((couponItem === null || couponItem === void 0 ? void 0 : couponItem.clientHeight) + space) * DEFAULT_SHOWN_COUPON_NUM}px`
        };
      }
      return {
        height: 'auto'
      };
    });
    var filterPromotionStatus = promotionStatus => {
      return Object.keys(promotionStatus).reduce((result, key) => {
        if (promotionStatus[key] !== COUPON_STATUS.UNKNOWN) {
          result[key] = promotionStatus[key];
        }
        return result;
      }, {});
    };
    var cptCouponWidgetStyle = computed(() => {
      return {
        paddingBottom: props.properties.bottomSpacing
      };
    });
    var handleCouponData = data => {
      var isFreeShipping = data.promotionSubCategory === PROMOTION_SUB_CATEGORY.FST;
      var termOfValidity = `${constants.formatTimestamp(data.startDate, 'date', '/')} - ${constants.formatTimestamp(data.endDate, 'date', '/')}`;
      if (isFreeShipping) {
        return {
          priceText: t('modules.couponsList.FREE_SHIPPING'),
          description: t('modules.couponsList.ZERO_THRESHOLD_FREE_SHIPPING'),
          requirement: '',
          isShowCurrencyUnit: false,
          termOfValidity
        };
      }
      return {
        priceText: getKeywordHighlightPart(data),
        description: getCouponThresholdDescription(data),
        requirement: t('modules.couponsList.ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION'),
        isShowCurrencyUnit: true,
        termOfValidity
      };
    };
    var getCouponList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(couponIds, isLogin, data) {
        var _yield$getPromotionIn, promotionList, list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (couponIds.length) {
                _context.next = 3;
                break;
              }
              couponList.value = [];
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return getPromotionInfosByPromotionIds(couponIds);
            case 5:
              _yield$getPromotionIn = _context.sent;
              promotionList = _yield$getPromotionIn.data.miniAppPromotionList;
              list = [];
              promotionList.forEach(item => {
                list.push(_objectSpread(_objectSpread({}, item), {}, {
                  status: isLogin ? data[item.encryptedPromotionId] : COUPON_STATUS.ACTIVE
                }, handleCouponData(item)));
              });
              couponList.value = list;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getCouponList(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var getCouponInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getPromotionSt, promotionStatus, promotionStatusObj;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getPromotionStatusByPromotionIds(`${convertListToQueryParameter(props.properties.couponIds, 'promotionIdList')}&encryptedMarketplaceId=${encryptedMarketplaceId}`);
            case 3:
              _yield$getPromotionSt = _context2.sent;
              promotionStatus = _yield$getPromotionSt.data;
              promotionStatusObj = filterPromotionStatus(promotionStatus);
              getCouponList(Object.keys(promotionStatusObj), true, promotionStatusObj);
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error('error--api---getPromotionStatusByPromotionIds');
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return function getCouponInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getCouponInfoNotAuthenticated = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              getCouponList(props.properties.couponIds, false);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getCouponInfoNotAuthenticated() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted(() => {
      Bridge.callFn(IS_AUTHENTICATED, {}, ({
        result
      }) => {
        if (result) {
          getCouponInfo();
        } else {
          getCouponInfoNotAuthenticated();
        }
      });
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.couponWidgetWidget), recordParams));
    });
    var handleRedeemPromotion = promotionId => {
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.claimCouponButton), {}, {
        couponid: promotionId
      }));
      Bridge.callFn(IS_AUTHENTICATED, {}, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4({
          result
        }) {
          var _yield$redeemPromotio, data;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!result) {
                  _context4.next = 15;
                  break;
                }
                _context4.prev = 1;
                _context4.next = 4;
                return redeemPromotionForCurrentCustomer({
                  encryptedPromotionId: promotionId,
                  encryptedMarketId: encryptedMarketplaceId
                });
              case 4:
                _yield$redeemPromotio = _context4.sent;
                data = _yield$redeemPromotio.data;
                if (data.status === API_RESPONSE_STATUS_CODE.SUCCESS.toString()) {
                  showToast({
                    message: t('modules.couponsList.CLAIMED_SUCCESSFULLY'),
                    icon: constants.SUCCESS_ICON_IMAGE_URL,
                    overlay: false,
                    overlayClass: 'a-overlay-white',
                    className: 'a-toast'
                  });
                }
                getCouponInfo();
                _context4.next = 13;
                break;
              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](1);
                console.error(_context4.t0, 'api---error---redeemPromotionForCurrentCustomer');
              case 13:
                _context4.next = 16;
                break;
              case 15:
                Bridge.callFn('startLogin', {}, () => {});
              case 16:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[1, 10]]);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    };
    return (_ctx, _cache) => {
      var _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", {
        class: "coupon-widget",
        style: _normalizeStyle(cptCouponWidgetStyle.value)
      }, [couponList.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "coupon-widget-list",
        style: _normalizeStyle(cptCouponListStyle.value),
        ref_key: "couponListContainerRef",
        ref: couponListContainerRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(couponList.value, item => {
        return _openBlock(), _createBlock(CouponItem, {
          key: item.encryptedPromotionId,
          couponItem: item,
          couponConfig: __props.properties,
          onHandleRedeemPromotion: $event => handleRedeemPromotion(item.encryptedPromotionId)
        }, null, 8, ["couponItem", "couponConfig", "onHandleRedeemPromotion"]);
      }), 128))], 4), couponList.value.length > _unref(DEFAULT_SHOWN_COUPON_NUM) && !isShowAllCoupon.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "see-more",
        onClick: _cache[0] || (_cache[0] = () => (isShowAllCoupon.value = true, emit('updateSlideHeight', true)))
      }, [_createTextVNode(_toDisplayString(_unref(t)('modules.couponsList.SEE_MORE')) + " ", 1), _createVNode(_component_van_icon, {
        name: "arrow-down"
      })])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 4);
    };
  }
};